import React, {PureComponent} from 'react';
import {withTranslation} from "react-i18next";

class PopoutStream extends PureComponent {

    render() {
        return (
            <div>
                <iframe
                    title={"cockpitView"}
                    height={parseInt("1080", 10)}
                    width={parseInt("1920", 10)}
                    src={"https://www.youtube.com/embed/" + this.props.match.params.streamID}
                />
            </div>
        );
    }

}

export default withTranslation("translations")(PopoutStream);